module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAIVBMVEVHcEz///////////////////////////////////////+PBM77AAAACnRSTlMAxZJ2LAzytVjcxI6LygAAAMJJREFUKM9jYBFbhQESHRi6VmEBKxiksAkvZMjCJryMoQqb8HIGN2zCKQws6oIYoMiBgcqANQCrsNVibKJMq1YpYBHWWrVqEaZoOMgbpRj2gYNsObqtgRBfi6KKssyCCK9E9bYnLJCmoCiGh/oyZOVuyGEKBxzIYd0AF0aJ5gyYKDNq1BggvI0MFsHDCBWAQ4wVI+7BQRCIGfGlmCbDTMchHGFsbDwLIbQSyG2FOtELIbwEKUy4EMILRpwwIoKWQRIzAD2vSrM19tJSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top.png
// module id = rOIf
// module chunks = 8